@if (!responsive.isMobileSignal()) {
  <app-img-header
    title="Cotizador comercial"
    alt="Daimler Truck"
    image="/assets/images/cotizador/intro.jpg"
    [contentTemplate]="template"
  >
  </app-img-header>
  <app-preloader *ngIf="isLoading()"></app-preloader>
  <app-notifications></app-notifications>
  <main class="main" id="">
    <div id="detail" class="white">
      <div class="pageWidth">
        <div class="actionsWrapper">
          <button class="tertiary" [routerLink]="['/quote/open-quote/new-open-quote']">
            <i class="icon"></i> Nueva cotización
          </button>
        </div>
        <div *ngIf="!hasData" class="noData">No hay información disponible</div>
        <div class="customTable listadoCotizacionesComerciales" *ngIf="hasData">
          <div class="header">
            <div class="cell numero">Nº</div>
            <div class="cell cotizacion">Nombre de la cotización</div>
            <div class="cell cliente">Nombre del cliente</div>
            <div class="cell propuestas">Propuestas</div>
            <div class="cell fa">Total FA</div>
            <div class="cell propietario">Propietario</div>
            <div class="cell edicion">Última edición</div>
            <div class="cell estado">Estado</div>
            <div class="cell rorac">RoRAC</div>
            <div class="cell acciones"></div>
          </div>

          <div *ngFor="let quote of data" class="row">
            <div class="cell numero">
              {{ quote.id }}
            </div>
            <!-- Si contiene más de 21 caracteres mostrar helipopper -->
            <div class="cell cotizacion">
              <span
                *ngIf="quote.quoteName.length > 20; else shortQuoteName"
                tp="{{ quote.quoteName }}"
                style="max-width: none; overflow: visible; white-space: nowrap"
              >
                {{ quote.quoteName }}
              </span>

              <ng-template #shortQuoteName>{{ quote.quoteName }}</ng-template>
            </div>
            <!-- Si contiene más de 17 caracteres mostrar helipopper -->
            <div class="cell cliente">
              <span *ngIf="quote?.customerName?.length > 17; else shortCustomerName" tp="{{ quote?.customerName }}">
                {{ quote?.customerName }}
              </span>
              <ng-template #shortCustomerName>{{ quote?.customerName }}</ng-template>
            </div>
            <div class="cell propuestas">
              {{ quote.dealAmount }}
            </div>

            <div class="cell fa">
              {{ formatInputValue(quote.faTotal) }}
            </div>
            <!-- Si contiene más de 21 caracteres mostrar helipopper -->
            <div class="cell propietario">
              <span *ngIf="quote.userName && quote.userName?.length > 21; else shortUserName" tp="{{ quote.userName }}">
                {{ quote.userName }}
              </span>
              <ng-template #shortUserName>{{ quote.userName }}</ng-template>
            </div>
            <div class="cell edicion">
              {{ format(quote.updatedDate, true) }}
            </div>
            <div class="cell estado">
              {{ getStatus(quote.status) }}
            </div>
            <div class="cell rorac">
              <ng-container *ngIf="quote.roRac">
                {{ quote.roRac ? quote.roRac : '' }}
                <span>%</span>
              </ng-container>
            </div>
            <div class="cell acciones">
              <a
                *ngIf="userId != quote.userId"
                tp="Ver cotización"
                [routerLink]="['/quote/edit-quote-open/' + quote.id]"
                [queryParams]="{ view: 'readonly' }"
                class="view"
                >Ver</a
              >
              <a
                *ngIf="userId == quote.userId && quoteIsTerminalCustomerOnly(quote)"
                tp="Ver cotización"
                [routerLink]="['/quote/edit-quote-open/' + quote.id]"
                [queryParams]="{ view: 'readonly' }"
                class="view"
              >
                Ver
              </a>
              <a
                *ngIf="userId == quote.userId && quoteIsInReview(quote) && quote.linkedToCreditRequest !== true"
                tp="Ver cotización"
                [routerLink]="['/quote/edit-quote-open/' + quote.id]"
                class="view"
              >
                Ver
              </a>
              <a
                *ngIf="userId == quote.userId && quoteIsInReview(quote) && quote.linkedToCreditRequest === true"
                tp="Ver cotización"
                [routerLink]="['/quote/edit-quote-open/' + quote.id]"
                [queryParams]="{ view: 'readonly' }"
                class="view"
              >
                Ver
              </a>
              <a
                *ngIf="userId == quote.userId && !quoteBlocksEditAndDelete(quote) && quote.linkedToCreditRequest !== true"
                tp="Editar cotización"
                [routerLink]="['/quote/edit-quote-open/' + quote.id]"
                class="edit"
              >
                Editar
              </a>
              <a
                *ngIf="userId == quote.userId && !quoteBlocksEditAndDelete(quote) && quote.linkedToCreditRequest === true"
                tp="Ver cotización"
                [routerLink]="['/quote/edit-quote-open/' + quote.id]"
                [queryParams]="{ view: 'readonly' }"
                class="view"
              >
                Ver
              </a>
              <a tp="Duplicar cotización" class="duplicate" (click)="openModalConfirmationToDuplicateOpenQuote(quote)">
                Duplicar</a
              >
              <a
                *ngIf="canExtendOpenQuoteValidity(quote)"
                tp="Extender vigencia"
                class="edit"
                (click)="extendOpenQuoteValidity(quote, $event)"
                >Extender vigencia</a
              >
              <a
                *ngIf="userId == quote.userId && !quoteBlocksEditAndDelete(quote) && quote.linkedToCreditRequest !== true"
                tp="Eliminar cotización"
                (click)="openModalConfirmation(quote)"
                class="delete"
                >Eliminar</a
              >
            </div>
          </div>
        </div>
        <!--
      <div *ngif="isMobile && hasData">
        <app-quote-mobile [listQuote]="data"></app-quote-mobile>
      </div>
      -->

        <div *ngIf="hasData">
          <app-paginator
            [total]="total"
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
            (changePage)="handlePage($event)"
          ></app-paginator>
        </div>

        <div class="actionsWrapper">
          <button class="tertiary" [routerLink]="['/quote/open-quote/new-open-quote']">
            <i class="icon"></i> Nueva cotización
          </button>
        </div>
      </div>
    </div>
  </main>
  <ng-template #template>
    <div class="wrapperG4">
      <div>
        <label>Estado</label>
        <app-select
          [options]="status.data"
          [placeholder]="status.placeholder"
          (optionSelected)="filter($event, status.filterType)"
          [resetSelect]="reset"
        ></app-select>
      </div>
      <div>
        <label>Nombre de la cotización</label>
        <app-input
          [data]="searchNameQuote"
          (textSearch)="filter($event, 'quoteName')"
          [showIcon]="false"
          [resetInput]="reset"
        ></app-input>
      </div>
      <div>
        <label>Nombre del cliente</label>
        @if (isActiveClientCatalog) {
          <app-input-api-search
            [endpoint]="getAllClientsUrl()"
            httpMethod="POST"
            searchKey="customerName"
            labelKey="customerName"
            placeholder="Buscar cliente"
            [additionalParams]="readonlyAdditionalSearchClientParams"
            (searchSelected)="handleSearchClient($event)"
            (textChange)="handleTextChange($event)"
            [resetInput]="reset"
            [disableNotFound]="true"
          ></app-input-api-search>
        } @else {
          <app-input
            [data]="searchNameCustomer"
            (textSearch)="filter($event, 'customerName')"
            [showIcon]="false"
            [resetInput]="reset"
          ></app-input>
        }
      </div>

      <div>
        <label>Propietario</label>
        <app-select
          [options]="owners"
          [placeholder]="'Seleccione un propietario'"
          (optionSelected)="filter($event, 'userId')"
          [resetSelect]="reset"
        ></app-select>
      </div>
      @if (isActiveClientCatalog) {
        <div>
          <label>Tipo de cliente</label>
          <app-select
            [options]="customerTypeList"
            [placeholder]="'Buscar por registro RFC'"
            [defaultValue]="params.filter.isExternalCustomer"
            (optionSelected)="filter($event, 'isExternalCustomer')"
            [resetSelect]="reset"
          ></app-select>
        </div>
      }
      @if (isActiveClientCatalog) {
        <div>
          <app-date-picker
            [isRange]="true"
            label="Fecha de actualización"
            placeholderFrom="Desde"
            placeholderTo="Hasta"
            [selectedDateFrom]="params.filter.from"
            [selectedDateTo]="params.filter.to"
            [allowFutureDates]="false"
            (selectedDateFromChange)="filter($event, 'from')"
            (selectedDateToChange)="filter($event, 'to')"
          ></app-date-picker>
        </div>
      } @else {
        <div>
          <app-date-picker
            [isRange]="true"
            label="Fecha de actualización"
            placeholderFrom="Desde"
            placeholderTo="Hasta"
            [selectedDateFrom]="params.filter.from"
            [selectedDateTo]="params.filter.to"
            [allowFutureDates]="false"
            (selectedDateFromChange)="filter($event, 'from')"
            (selectedDateToChange)="filter($event, 'to')"
          ></app-date-picker>
        </div>
      }
      <div>
        <label class="checkboxWrapper myQuotation" for="myQuotation">
          <input
            type="checkbox"
            id="myQuotation"
            [(ngModel)]="params.filter.me"
            (ngModelChange)="filter($event, 'me')"
          />
          <span class="checkmark"></span>
          <span class="description">Mis cotizaciones</span>
        </label>
      </div>
    </div>
    <div class="filtersActions">
      <button class="primary" (click)="search()">Buscar</button>
      <button class="secondary" (click)="resetFilters()">Limpiar filtros</button>
    </div>
  </ng-template>
  <ng-template #templateConfirmation>
    <app-template-confirmation
      [title]="title"
      [subtitle]="subtitle"
      [btn1]="btn1"
      [btn2]="btn2"
      (closeModal)="closeModal()"
      (actionBtn2)="deleteQuoteById()"
    ></app-template-confirmation>
  </ng-template>
} @else {
  @defer (when responsive.isMobileSignal()) {
    <app-list-open-quote-mobile />
  }
}
<ng-template #templateDuplicateQuote>
  <app-template-confirmation
    [title]="title"
    [subtitle]="subtitle"
    [btn1]="btn1"
    [btn2]="btn2"
    (closeModal)="closeModal()"
    (actionBtn2)="duplicateQuoteById()"
  ></app-template-confirmation>
</ng-template>
